<template>
  <div class="field-holder-group">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .field-holder-group {
    flex: 100%;
    display: flex;
    flex-wrap: wrap;

    .field-holder {
      margin: 0;

      &.split {
        &:nth-child(2n + 1) {
          padding-left: 0;
        }

        &:last-child {
          margin-bottom: 10px;
        }
      }

      &.inline {
        margin-bottom: 10px;

        ::v-deep input[type="number"],
        ::v-deep input[type="text"] {
          max-width: 80px;
        }
      }
    }

    &.column {
      flex-direction: column;

      .field-holder {
        margin-top: 0;
      }
    }

    &.spaced {
      margin-top: 10px;
    }

    &.multiple {
      .form-field-column {
        flex: 1;

        + .form-field-column {
          margin-left: 10px;
        }
      }

      .field-holder {
        margin-bottom: 10px;
      }
    }
  }
</style>

<script>
  export default {
    name: 'form-field-holder-group'
  }
</script>
